import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ConfigService } from "./config.service";

@Injectable({
  providedIn: 'root'
})
export class TrackerService {

  private config: { id: string } | undefined;

  constructor(
    private configService: ConfigService,
    private httpClient: HttpClient
  ) {
    this.configService.config$.subscribe((config) => {
      if(config) {
        this.config = config;
      }
    });
  }

  /**
   * Fires the third-party ad conversion pixels (Meta + StackAdapt) loaded in index.html.
   * Safe to call when the pixels are not present (e.g. blocked by an ad blocker or local dev).
   */
  conversion(): void {
    const w = window as any;

    try {
      if (typeof w.fbq === 'function') {
        w.fbq('track', 'ViewContent');
      }
    } catch (e) {
      console.warn('Meta pixel conversion failed', e);
    }

    try {
      if (typeof w.saq === 'function') {
        w.saq('conv', 'dEG9mGD715lI4uOe9Lkl1I');
      }
    } catch (e) {
      console.warn('StackAdapt pixel conversion failed', e);
    }
  }

  register(event: any): Promise<any> {
    return new Promise((resolve, reject) => {
      if(this.config && this.config['id']) {
        this.httpClient.post(environment.api_v2_url + '/event/' + this.config['id'] + '/register', event)
          .subscribe({ next: resolve, error: reject });
      }
      else {
        reject('config not available - unable to post tracking information');
      }
    });
  }
}
